exports.BLOGS = 'blogs';
exports.RESOURCES = 'resources';
exports.NEWS = 'news';
exports.EVENTS = 'events';
exports.PRESS = 'press';
